/**
 * 选取关键 props 生成 key 字符串
 */
export default function getKeyPropsString(props: Record<string, any>): string {
  const keys = ['style', 'className', 'id', 'name', 'type', 'data']
  return keys
    .map(k => {
      if (k === 'data' && typeof props[k] === 'object' && props[k] !== null) {
        try {
          return JSON.stringify(props[k])
        } catch {
          return ''
        }
      }
      return props[k] !== undefined ? String(props[k]) : ''
    })
    .join('|')
}
